module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/240-azores-islands-758974ca334a053c0bf51b1391da5fd5.svg";